export default {
  headerContent: {
    title: 'Groupama Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'Groupama Sigorta Zorunlu Trafik Sigortası Nedir? ',
      content: [
        'Zorunlu trafik sigortası üçüncü şahıslara veya karşı tarafa vereceğiniz zararlara karşı yükümlülüklerinizi güvence altına almaktadır.',
        'Yaptırılması kanunen zorunlu olan trafik sigortasını Groupama Sigorta güvensi ile yaptırabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Zorunlu Trafik Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Gorupama Sigorta ana teminatları Hazine Müsteşarlığı tarafından belirlenmektedir.',
          subList: null
        },
        {
          paragraph: 'Bu Teminatlar;',
          subList: [
            'Maddi Giderler Teminatı',
            'Sağlık Giderleri Teminatı',
            'Sakatlanma Ve Ölüm Teminatı'
          ]
        },
        {
          paragraph: 'Olmak üzere 3 adet ana teminat bulunmaktadır.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
